export const valueIsColor = (val: string) => {
  try {
    return val.match(/^#(([\dA-Fa-f]{2}){3}|([\dA-Fa-f]){3})$/g);
  } catch {
    return false;
  }
};
